(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function initRecommendedCarousel(scope) {
    var sections;

    if (scope && scope.matches && scope.matches('.recommended-carousel')) {
      sections = [scope];
    } else {
      sections = scope ? scope.querySelectorAll('.recommended-carousel') : document.querySelectorAll('.recommended-carousel');
    }

    sections.forEach(function(section) {
      var track = section.querySelector('.recommended-carousel__track');
      var prevButton = section.querySelector('.recommended-carousel__button--prev');
      var nextButton = section.querySelector('.recommended-carousel__button--next');

      if (!track || !prevButton || !nextButton || section.dataset.carouselReady === 'true') {
        return;
      }

      section.dataset.carouselReady = 'true';

      function getStep() {
        var slide = track.querySelector('.recommended-carousel__slide');
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var canScrollLeft = track.scrollLeft > 0;
        var canScrollRight = track.scrollLeft < maxScroll;

        prevButton.disabled = !canScrollLeft;
        nextButton.disabled = !canScrollRight;
        section.classList.toggle('recommended-carousel--can-scroll-left', canScrollLeft);
        section.classList.toggle('recommended-carousel--can-scroll-right', canScrollRight);
      }

      prevButton.addEventListener('click', function() {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function() {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function loadProductRecommendationsIntoSection() {
    var sections = document.querySelectorAll('.product-recommendations[data-product-id]');

    sections.forEach(function(section) {
      var productId = section.dataset.productId;
      var limit = section.dataset.limit || 6;
      var requestUrl = Station.Theme.shop.root + 'recommendations/products?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
      var request = new XMLHttpRequest();

      request.open('GET', requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement('div');
          var nextSection;

          container.innerHTML = request.response;
          nextSection = container.querySelector('.product-recommendations');

          if (!nextSection) {
            return;
          }

          section.outerHTML = nextSection.outerHTML;
          initRecommendedCarousel();
        }
      };

      request.send();
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    loadProductRecommendationsIntoSection();
    initRecommendedCarousel();
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
